import KunLoading33 from './src/index'

KunLoading33.install = function (Vue) {
	Vue.component(KunLoading33.name, KunLoading33);
}

export default KunLoading33;
